/**
 * @fileoverview Route configuration for code-health feature.
 */

import { lazy } from 'react';
import { createRoutes } from '../utils/routeHelpers';

const CodeHealthPage = lazy(() => import('../../features/code-health/pages/CodeHealthPage'));
const CoverageReportPage = lazy(() => import('../../features/code-health/pages/CoverageReportPage'));

export const codeHealthRoutes = createRoutes([
  { path: 'code-health', Component: CodeHealthPage },
  { path: 'code-health/coverage', Component: CoverageReportPage },
]);
